import { all } from 'redux-saga/effects';
import { watchList } from './list';

export function* watchMedicalDegrees() {
  yield all([watchList()]);
}
